export const talksMain = [
  {
    time: '10:00 AM',
    title: 'Welcome to Schelling Point',
    name: `Simona Pop ◖ SP Content Curator`,
  },
  {
    time: '10:00 AM',
    title: 'Schelling Point Kickoff',
    name: 'Vitalik Buterin',
    link: 'https://youtu.be/K8tEQui7zEo'
  },
  {
    time: '10:30 AM',
    title: 'SuperModularity',
    name: 'Kevin Owocki ◖ supermodular.xyz',
    link: 'https://youtu.be/Z5TQpYDPv_M'
  },
  {
    time: '10:50 AM',
    title: 'Designing for Resilience: Decentralized Governance in Open-Source Ecosystems',
    name: 'Abbey Titcomb ◖ Radicle',
    link: 'https://youtu.be/9rlApiC-KSI'
  },
  {
    time: '11:10 AM',
    title: 'Creating welcoming, diverse, and sustainable developer communities',
    name: 'Kasia Sitkiewicz ◖ Github, Camila Ramos ◖ Fuel Labs, Nader Dabit ◖ DevDAO, Eric Nakagawa ◖ Celo',
    link: 'https://youtu.be/5T0qLIrIx5E'
  },
  {
    time: '11:40 AM',
    title: 'Why no one is using Blockchain?!',
    name: 'Fabian Vogelsteller ◖ LUKSO',
    link: 'https://youtu.be/uNo1CdT4Bwc'
  },
  {
    time: '12:05 PM',
    title: 'Plurality: Technology for Collaborative Diversity and Democracy',
    name: 'Glen Weyl ◖ RadicalxChange',
    link: 'https://youtu.be/utOQVWbZI7Q'
  },
  {
    time: '12:25 PM',
    title: 'LUNCH',
    name: '',
    calendar: ''
  },
  {
    time: '1:05 PM',
    title: 'Using social capital to coordinate digital economies',
    name: 'Danny Zuckerman ◖ Ceramic',
    link: 'https://youtu.be/wbnxPtAGgYA'
  },
  {
    time: '1:25 PM',
    title: 'Decentralized social media - a public good?',
    name: 'Manasi Vora ◖ Skynet',
    link: 'https://youtu.be/INifI8fv7IU'
  },
  {
    time: '1:45 PM',
    title: 'Cryoto Artistry and Collective Transformation',
    name: 'Shivani Mitra ◖ MOCA, Julian Brangold ◖ CruptoArg, Stefany Cuervo ◖ Colombian Artist, Bertie Lumsden ◖ ArtDAO, Rico Serna ◖ Chimbites',
    link: 'https://youtu.be/rPrcCe754a8'
  },
  {
    time: '2:15 PM',
    title: 'Communication is a Public Good',
    name: 'Harsh Rajat ◖ EPNS',
    link: 'https://youtu.be/Diln2WBL7a0'
  },
  {
    time: '2:35 PM',
    title: 'Open source as a public good',
    name: 'Jahed Momand ◖ Cerulean Ventures, Linda Xie ◖ Scalar Capital, Awa Lefteris Karapetsas ◖ Rotki, Scott Moore ◖ Gitcoin, Awa Sun Yin ◖ Anoma',
    link: 'https://youtu.be/I_JMDUo09Z0'
  },
  {
    time: '3:05 PM',
    title: 'Data Dating',
    name: 'Jonny Howle ◖ Disco, Carl Fairclough ◖ Disco',
    link: 'https://youtu.be/A4YiszKrZ1E'
  },
  {
    time: '3:30 PM',
    title: 'You Just DAO-ed it, now what?',
    name: 'Denison Bertram ◖ Tally, James Waugh ◖ fireeyes, Kris Decoodt ◖ Gitcoin, Simona Pop ◖ Schelling Point',
    link: 'https://youtu.be/vG-qedhMkQs'
  },
  {
    time: '4:00 PM',
    title: 'Decentralised Digital Communities: How, Why and When?',
    name: 'Rahul Kothari ◖ Reddit',
    link: 'https://youtu.be/lRNi00aQuaI'
  },
  {
    time: '4:20 PM',
    title: 'Onboarding Latam users and builders in the future of Web3',
    name: 'Pablo Sabbatella ◖ Defy Education',
    link: 'https://youtu.be/WAtVrEUqqWc'
  },
  {
    time: '4:40 PM',
    title: `Hot DAO Coordination Autumn - Let's figure out how your DAO actually coordinates`,
    name: 'Aaron Soskin ◖ govrn.io',
    link: 'https://youtu.be/45Mrnf37AB8'
  },
  {
    time: '5:00 PM',
    title: `Regenerative Employment is the Future of Work`,
    name: 'Josh Lapidus ◖ Opolis',
    link: 'https://youtu.be/I376WFv01LU'
  },
  {
    time: '5:20 PM',
    title: `Public Nouns (Mic) Drop - Special Announcement`,
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T222000Z%2F20221010T224000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Public%20Nouns%20%28Mic%29%20Drop%20-%20Special%20Announcement'
  },
];

export const talksPlurality = [
  {
    time: '10:00 AM',
    title: 'Web3 & Plurality Brunch hosted by RadicalxChange & Fundación Karisma',
    name: 'Paula Berman ◖ RadicalxChange, Andrés Velásquez ◖ Fundación Karisma, Daniel Knobelsdorf ◖ RadicalxChange',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T150000Z%2F20221010T170000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Web3%20%26%20Plurality%20Brunch%20hosted%20by%20RadicalxChange%20%26%20Fundaci%C3%B3n%20Karisma%20%28Paula%20Berman%20%E2%97%96%20RadicalxChange%2C%20Andr%C3%A9s%20Vel%C3%A1squez%20%E2%97%96%20Fundaci%C3%B3n%20Karisma%2C%20Daniel%20Knobelsdorf%20%E2%97%96%20RadicalxChange%29'
  },
  {
    time: '12:05 AM',
    title: '[ MAIN STAGE ] Plurality: Technology for Collaborative Diversity and Democracy',
    name: 'Glen Weyl ◖ RadicalxChange',
    link: 'https://youtu.be/utOQVWbZI7Q'
  },
  {
    time: '1:00 PM',
    title: 'Exploring a potential wormhole between Quadratic Funding and Quantum Mechanics',
    name: 'Michael Freedman ◖ Microsoft',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T180000Z%2F20221010T190000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Exploring%20a%20potential%20wormhole%20between%20Quadratic%20Funding%20and%20Quantum%20Mechanics%20%28Michael%20Freedman%20%E2%97%96%20Microsoft%29'
  },
  {
    time: '2:00 PM',
    title: 'Building Plural Tech — Lightning Presentations & Panel',
    name: 'Kevin Owocki ◖ supermodular.xyz, Christine Vandevoorde ◖ govrn.io, Aaron Soskin ◖ govrn.io, Guo Liu ◖ Matters Lab',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T190000Z%2F20221010T203000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Building%20Plural%20Tech%20%E2%80%94%20Lightning%20Presentations%20%26%20Panel%20%28Kevin%20Owocki%20%E2%97%96%20supermodular.xyz%2C%20Christine%20Vandevoorde%20%E2%97%96%20govrn.io%2C%20Aaron%20Soskin%20%E2%97%96%20govrn.io%2C%20Guo%20Liu%20%E2%97%96%20Matters%20Lab%29'
  },
  {
    time: '3:30 PM',
    title: 'Plural Publics',
    name: 'Shrey Jain ◖ Microsoft',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T203000Z%2F20221010T210000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Plural%20Publics%20%28Shrey%20Jain%20%E2%97%96%20Microsoft%29'
  },
  {
    time: '4:00 PM',
    title: 'Deep Dive on DeSoc',
    name: 'Puja Ohlhaver ◖ Flashbots, Special Guest',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T210000Z%2F20221010T220000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Deep%20Dive%20on%20DeSoc%20%28Puja%20Ohlhaver%20%E2%97%96%20Flashbots%2C%20Special%20Guest%29'
  },
];

export const talksFTC = [
  {
    time: '10:20 AM',
    title: 'Intro',
    name: 'Evan Miyazono ◖ Protocol Labs',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T152000Z%2F20221010T153500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Intro%20%28Evan%20Miyazono%20%E2%97%96%20Protocol%20Labs%29'
  },
  {
    time: '10:35 AM',
    title: 'Radicle Drips - the latest mechanism design',
    name: 'Andrew Dickson ◖ Radicle',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T153500Z%2F20221010T160000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Radicle%20Drips%20-%20the%20latest%20mechanism%20design%20%28Andrew%20Dickson%20%E2%97%96%20Radicle%29'
  },
  {
    time: '11:00 AM',
    title: 'Rewarding impact with Hypercerts.xyz',
    name: 'Holke Brammer ◖ Protocol Labs and Kevin Owocki ◖ supermodular.xyz',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T160000Z%2F20221010T162500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Rewarding%20impact%20with%20Hypercerts.xyz%20%28Holke%20Brammer%20%E2%97%96%20Protocol%20Labs%20and%20Kevin%20Owocki%20%E2%97%96%20supermodular.xyz%29'
  },
  {
    time: '11:25 AM',
    title: 'FiatConnect & Connect the World - Using Competitions to Bootstrap Public Goods',
    name: 'Marek Olszewski ◖ Celo/cLabs',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T162500Z%2F20221010T165000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=FiatConnect%20%26%20Connect%20the%20World%20-%20Using%20Competitions%20to%20Bootstrap%20Public%20Goods%20%28Marek%20Olszewski%20%E2%97%96%20Celo%2FcLabs%29'
  },
  {
    time: '11:50 AM',
    title: 'Investing in Network Goods: new ecosystem funding paradigms',
    name: 'Anna Kryukova ◖ Celo, Scott Moore ◖ Gitcoin, Abbey Titcomb ◖ Radicle',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T165000Z%2F20221010T173000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Investing%20in%20Network%20Goods%3A%20new%20ecosystem%20funding%20paradigms%20%28Anna%20Kryukova%20%E2%97%96%20Celo%2C%20Scott%20Moore%20%E2%97%96%20Gitcoin%2C%20Abbey%20Titcomb%20%E2%97%96%20Radicle%29'
  },
  {
    time: '12:30 PM',
    title: 'BREAK',
    name: '',
    calendar: ''
  },
  {
    time: '12:45 PM',
    title: 'Impact Evaluators: Existential risks and opportunities',
    name: 'Matthew Frehlich ◖ Protocol Labs',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T173000Z%2F20221010T175500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Impact%20Evaluators%3A%20Existential%20risks%20and%20opportunities%20%28Matthew%20Frehlich%20%E2%97%96%20Protocol%20Labs%29'
  },
  {
    time: '1:10 PM',
    title: 'Complex Products: Where DAOs and funding mechanisms fall short',
    name: 'Daphne Charles ◖ Kiwi Labs, Pooja Shah ◖ Tephra Labs, Juan Guillen ◖ MakerDAO',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T181000Z%2F20221010T185000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Complex%20Products%3A%20Where%20DAOs%20and%20funding%20mechanisms%20fall%20short%20%28Daphne%20Charles%20%E2%97%96%20Kiwi%20Labs%2C%20Pooja%20Shah%20%E2%97%96%20Tephra%20Labs%2C%20Juan%20Guillen%20%E2%97%96%20MakerDAO%29'
  },
  {
    time: '1:50 PM',
    title: 'Workshops: Funding Mechanisms',
    name: 'Marcus Aurelius ◖ KlimaDAO, Livia De ◖ Commons Stack',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T185000Z%2F20221010T194500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Workshops%3A%20Funding%20Mechanisms%20%28Marcus%20Aurelius%20%E2%97%96%20KlimaDAO%2C%20Livia%20De%20%E2%97%96%20Commons%20Stack%29'
  },
  {
    time: '2:45 PM',
    title: 'BREAK',
    name: '',
    calendar: ''
  },
  {
    time: '3:00 PM',
    title: 'Workshops: Impact Markets',
    name: 'Holke Brammer ◖ Protocol Labs, Rhys Lindmark ◖ Roote/Web3 & Society, Manu Alzuru ◖ DoinGud',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T200000Z%2F20221010T205500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Workshops%3A%20Impact%20Markets%20%28Holke%20Brammer%20%E2%97%96%20Protocol%20Labs%2C%20Rhys%20Lindmark%20%E2%97%96%20Roote%2FWeb3%20%26%20Society%2C%20Manu%20Alzuru%20%E2%97%96%20DoinGud%29'
  },
  {
    time: '3:55 PM',
    title: 'Workshops: Funding Structures',
    name: 'Rene Pinnell ◖ Artizen Fund, Vaughn McKenzie-Landell ◖ Butter',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T205500Z%2F20221010T215000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Workshops%3A%20Funding%20Structures%20%28Rene%20Pinnell%20%E2%97%96%20Artizen%20Fund%2C%20Vaughn%20McKenzie-Landell%20%E2%97%96%20Butter%29'
  },
  {
    time: '4:50 PM',
    title: 'End of Day',
    name: 'Evan Miyazono ◖ Protocol Labs',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T215000Z%2F20221010T220000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=End%20of%20Day%20%28Evan%20Miyazono%20%E2%97%96%20Protocol%20Labs%29'
  },
  {
    time: '5:00 PM',
    title: 'Matchmaking',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T220000Z%2F20221010T230000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Matchmaking'
  },
];

export const talksDeSci = [
  {
    time: '10:00 AM',
    title: 'Kickoff',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T150000Z%2F20221010T151000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Kickoff'
  },
  {
    time: '10:10 AM',
    title: `Web3's role in enhancing Climate Action`,
    name: 'Erin Murphy ◖ Topl, Ester Fonseca ◖ Carbonfi, John Hoopes ◖ Toucan, Ryan Christoffersen ◖ Regen, Lea Bauer ◖ Flow, Marc Johnson ◖ Moderator',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T151000Z%2F20221010T155500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Web3%27s%20role%20in%20enhancing%20Climate%20Action%20%28Erin%20Murphy%20%E2%97%96%20Topl%2C%20Ester%20Fonseca%20%E2%97%96%20Carbonfi%2C%20John%20Hoopes%20%E2%97%96%20Toucan%2C%20Ryan%20Christoffersen%20%E2%97%96%20Regen%2C%20Lea%20Bauer%20%E2%97%96%20Flow%2C%20Marc%20Johnson%20%E2%97%96%20Moderator%29'
  },
  {
    time: '10:55 AM',
    title: 'Filecoin Green: Global Carbon Ledger',
    name: 'Alan Ransil ◖ Filecoin Green',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T155500Z%2F20221010T162000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Filecoin%20Green%3A%20Global%20Carbon%20Ledger%20%28Alan%20Ransil%20%E2%97%96%20Filecoin%20Green%29'
  },
  {
    time: '11:20 AM',
    title: 'Overview: Climate Policy Landscape',
    name: 'John Hoopes ◖ Toucan',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T162000Z%2F20221010T164500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Overview%3A%20Climate%20Policy%20Landscape%20%28John%20Hoopes%20%E2%97%96%20Toucan%29'
  },
  {
    time: '11:45 AM',
    title: 'KokoDAO: Reducing Deforestation in Colombia',
    name: 'Ana Maria Mahecha ◖ KokoDAO',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T164500Z%2F20221010T171000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=KokoDAO%3A%20Reducing%20Deforestation%20in%20Colombia%20%28Ana%20Maria%20Mahecha%20%E2%97%96%20KokoDAO%29'
  },
  {
    time: '12:10 PM',
    title: 'LUNCH',
    name: '',
    calendar: ''
  },
  {
    time: '12:55 PM',
    title: 'Infrastructure Workshop',
    name: 'Andros Wong ◖ Wonder, Aleksandra Smilek ◖ Foresight, Daniel Uribe ◖ Genobank, Michael Fischer ◖ CurateDAO',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T175500Z%2F20221010T185000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Infrastructure%20Workshop%20%28Andros%20Wong%20%E2%97%96%20Wonder%2C%20Aleksandra%20Smilek%20%E2%97%96%20Foresight%2C%20Daniel%20Uribe%20%E2%97%96%20Genobank%2C%20Michael%20Fischer%20%E2%97%96%20CurateDAO%29'
  },
  {
    time: '1:50 PM',
    title: 'BioDAOs Workshop',
    name: 'Paul Kohlhaas ◖ Molecule, Tyler Golato ◖ Molecule',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T185000Z%2F20221010T193500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=BioDAOs%20Workshop%20%28Paul%20Kohlhaas%20%E2%97%96%20Molecule%2C%20Tyler%20Golato%20%E2%97%96%20Molecule%29'
  },
  {
    time: '2:35 PM',
    title: 'DeSci in LatAm',
    name: 'Carolina Menchaca ◖ DeSci.World',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T193500Z%2F20221010T201500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=DeSci%20in%20LatAm%20%28Carolina%20Menchaca%20%E2%97%96%20DeSci.World%29'
  },
  {
    time: '3:15 PM',
    title: 'Health Workshop',
    name: 'Laura Minquini ◖ AthenaDAO, Oksana Stanevich ◖ MD, Researcher',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T201500Z%2F20221010T210000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Health%20Workshop%20%28Laura%20Minquini%20%E2%97%96%20AthenaDAO%2C%20Oksana%20Stanevich%20%E2%97%96%20MD%2C%20Researcher%29'
  },
  {
    time: '4:00 PM',
    title: `Promise & Peril Area`,
    name: 'Vincent Weisser ◖ vitaDAO, Renée Davis ◖ SCRF, TalentDAO',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T210000Z%2F20221010T215000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Promise%20%26%20Peril%20Area%20%28Vincent%20Weisser%20%E2%97%96%20vitaDAO%2C%20Ren%C3%A9e%20Davis%20%E2%97%96%20SCRF%2C%20TalentDAO%29'
  },
  {
    time: '4:50 PM',
    title: 'Closing Remarks',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T215000Z%2F20221010T215500Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Closing%20Remarks%20'
  },
];

export const talksWellness = [
  {
    time: 'All day',
    title: 'Natural Aromatherapy',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010%2F20221011&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Natural%20Aromatherapy'
  },
  {
    time: '9:00 AM',
    title: 'Morning meditation session with muscular movements - Session 1',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T140000Z%2F20221010T143000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Morning%20meditation%20session%20with%20muscular%20movements%20-%20Session%201'
  },
  {
    time: '9:30 AM',
    title: 'Morning meditation session with muscular movements - Session 2',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T143000Z%2F20221010T150000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Morning%20meditation%20session%20with%20muscular%20movements%20-%20Session%202'
  },
  {
    time: '11:00 AM',
    title: 'Crystal bowl and sound meditation',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T160000Z%2F20221010T163000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Crystal%20bowl%20and%20sound%20meditation'
  },
  {
    time: '12:00 - 17:30 PM',
    title: 'Colombian Cacao Tasting',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T170000Z%2F20221010T223000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Colombian%20Cacao%20Tasting'
  },
  {
    time: '14:30 PM',
    title: 'Cacao Mindful-eating Tasting',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T193000Z%2F20221010T200000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Cacao%20Mindful-eating%20Tasting'
  },
  {
    time: '15:00 PM',
    title: 'Body work DIY coaching',
    name: '',
    calendar: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20221010T200000Z%2F20221010T203000Z&details=&location=gran%20carpa%20am%C3%A9ricas%20corferias&text=Body%20work%20DYI%20coaching'
  },
];
